import styled from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

const CARD_HEIGHT = 162;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;
`;

export const ImageContainer = styled.div`
  min-width: 280px;
  min-height: ${CARD_HEIGHT}px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: space-between;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

export const BottomControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 40px;
  }
`;
